import React from 'react';
import { Outlet } from 'react-router-dom';

const Associations: React.FC = () => <Outlet />;

export default Associations;
